const Woods = () => {
  return (
    <g id="woods">
      <path
        id="bottom"
        d="M188.224 1.28235H203.612C204.32 1.28235 204.894 1.85648 204.894 2.56471V358.718H186.941V2.56471C186.941 1.85648 187.515 1.28235 188.224 1.28235Z"
        fill="#FCBF49"
        stroke="#6D6875"
        strokeWidth={2.56471}
      />
      <path
        id="cross"
        d="M143.796 33.4286H126.671L185.659 87.4286V71.3572L143.796 33.4286Z"
        fill="#6D6875"
        stroke="#6D6875"
        strokeWidth={2.56471}
      />
      <path
        id="up"
        d="M3.56471 14.1395H216.435C217.144 14.1395 217.718 14.7137 217.718 15.4219V30.8639C217.718 31.5721 217.144 32.1463 216.435 32.1463H3.56472C2.85649 32.1463 2.28235 31.5721 2.28235 30.8639V15.4219C2.28235 14.7137 2.85648 14.1395 3.56471 14.1395Z"
        fill="#FCBF49"
        stroke="#6D6875"
        strokeWidth={2.56471}
      />
    </g>
  );
};

export default Woods;
